angular
	.module 'App.Repository'
	.factory 'ProductSuggestionRepository', [
		'BaseRepository',
		(BaseRepository) ->
			class ProductSuggestionRepository extends BaseRepository
				@resource = '/product_suggestions'
				@isRestricted = true

			return new ProductSuggestionRepository
	]
